import { render, staticRenderFns } from "./DoctorFilterDropdown.vue?vue&type=template&id=1458cfec&scoped=true&lang=pug&"
import script from "./DoctorFilterDropdown.vue?vue&type=script&lang=js&"
export * from "./DoctorFilterDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DoctorFilterDropdown.vue?vue&type=style&index=0&id=1458cfec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1458cfec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VMenu,VSkeletonLoader,VSpacer,VTextField})
